"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCORSBus = void 0;
require("reflect-metadata");
var inversify_1 = require("inversify");
var cors_bus_1 = require("./cors-bus");
var bus_event_1 = require("./bus-event");
var bus_broadcast_1 = require("./bus-broadcast");
var bus_request_1 = require("./bus-request");
var utils_1 = require("./utils");
var config_1 = require("./config");
var createCORSBus = function (id, root) {
    if (root === void 0) { root = false; }
    var container = new inversify_1.Container();
    container.bind(bus_event_1.BusEvent).to(bus_event_1.BusEvent).inSingletonScope();
    container.bind(bus_broadcast_1.BusBroadCast).to(bus_broadcast_1.BusBroadCast).inSingletonScope();
    container.bind(utils_1.Utils).to(utils_1.Utils).inSingletonScope();
    container.bind(bus_request_1.BusRequest).to(bus_request_1.BusRequest).inSingletonScope();
    container.bind(config_1.Config).to(config_1.Config).inSingletonScope();
    container.bind(cors_bus_1.CORSBus).to(cors_bus_1.CORSBus);
    var bus = container.get(cors_bus_1.CORSBus);
    var config = container.get(config_1.Config);
    config.id = id;
    root && (config.cbusRootWindow = window);
    bus.init();
    return bus;
};
exports.createCORSBus = createCORSBus;
//# sourceMappingURL=index.js.map